module.exports = __webpack_public_path__ + "static/media/bts_carassauga_180526_001_small.b8011f2f.jpg";